import { endOfDay } from "date-fns";

export default function isOverdue(completed_at, scheduled_for) {
    if (completed_at) {
        return (
            endOfDay(new Date(completed_at)) > endOfDay(new Date(scheduled_for))
        );
    }

    return (
        scheduled_for &&
        endOfDay(new Date()) > endOfDay(new Date(scheduled_for))
    );
}
